import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="listfiles">
                1.&nbsp;<span className="material-symbols-outlined">snippet_folder</span>&nbsp;{translate('listfiles')}
            </Typography>
            <p><strong>{translate('listfiles')}</strong> is an act of retrieving a list of files in a directory.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$listFiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the directory path. Type <strong>/tmp</strong> to specify the root directory.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('fullpath')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">rule</span>
                                        <span>{translate('datatype__any')}</span>
                                    </div>
                                </td>
                                <td>As an option to retrieve the absolute path of a file, if the <strong>{translate('fullpath')}</strong> switch is on (true), the result will be an array of absolute paths list.</td>
                                <td>false</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Get a list of files located inside the <strong>/tmp/download</strong> folder.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$listFiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('directory')}</span>
                            <div>/tmp/download</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "file_1.xlsx"
                                            ,"file_2.pdf"
                                            ,"file_3.png"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="renamefile">
                2.&nbsp;<span className="material-symbols-outlined">edit_document</span>&nbsp;{translate('renamefile')}
            </Typography>
            <p><strong>{translate('renamefile')}</strong> is an act of renaming a file. Please note that the extension will not be changed.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$renamefile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the file you want to rename.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The new file name.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Change the filename <strong>file_1.xlsx</strong> to <strong>report.xlsx</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$renamefile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_1.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>report</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/download/report.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="movefiles">
                3.&nbsp;<span className="material-symbols-outlined">drive_file_move</span>&nbsp;{translate('movefiles')}
            </Typography>
            <p><strong>{translate('movefiles')}</strong> is an action that changes the storage directory of one or more files.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$moveFiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of one or more files you want to move. In the case of multiple files, the paths of the files must be separated by commas.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the destination directory path. Type <strong>/tmp</strong> to specify the root directory.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Change the file storage directory <strong>file_2.pdf</strong> from <strong>/tmp/download</strong> to <strong>/tmp/document</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$moveFiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_2.pdf</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>/tmp/document</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/document/file_2.pdf"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="deletefiles">
                4.&nbsp;<span className="material-symbols-outlined">folder_delete</span>&nbsp;{translate('deletefiles')}
            </Typography>
            <p><strong>{translate('deletefiles')}</strong> is the act of deleting one or more files.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of one or more files you want to delete. In the case of multiple files, the paths of the files must be separated by commas.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Delete the file <strong>file_2.pdf</strong> in the <strong>/tmp/document</strong> folder.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/document/file_2.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="copyfiles">
                5.&nbsp;<span className="material-symbols-outlined">file_copy</span>&nbsp;{translate('copyfiles')}
            </Typography>
            <p><strong>{translate('copyfiles')}</strong> is an act of copying one or more files.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$copyfiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of one or more files you want to copy. In the case of multiple files, the paths of the files must be separated by commas.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the destination directory path. Type <strong>/tmp</strong> to specify the root directory.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Copy the file <strong>file_3.png</strong> from <strong>/tmp/download</strong> to <strong>/tmp/document</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$moveFiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_3.png</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>/tmp/document</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/document/file_3.png"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="compressfiles">
                6.&nbsp;<span className="material-symbols-outlined">folder_zip</span>&nbsp;{translate('compressfiles')}
            </Typography>
            <p><strong>{translate('compressfiles')}</strong> is an action to compress one or more files into a ZIP file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$compressfiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of one or more files you want to compress. In the case of multiple files, the paths of the files must be separated by commas.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the file name after compression.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Compress <strong>file_1.xlsx,file_2.pdf,file_3.png</strong> in <strong>/tmp/download</strong> to <strong>all_files.zip</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$compressfiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_1.xlsx,/tmp/download/file_2.pdf,/tmp/download/file_3.png</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>all_files</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/download/all_files.zip</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="decompressfiles">
                7.&nbsp;<span className="material-symbols-outlined">folder_zip</span>&nbsp;{translate('decompressfiles')}
            </Typography>
            <p><strong>{translate('decompressfiles')}</strong> is an action to extract a ZIP file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$decompressfiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the ZIP file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Specify the character encoding of the archive. If the filename after expansion contains Japanese characters, the characters may be garbled. You can prevent garbled characters by specifying a character code.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Extract the file <strong>all_files.zip</strong> in the folder <strong>/tmp/download</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$decompressfiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/all_files.zip</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>      
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/download/file_1.xlsx"
                                            ,"/tmp/download/file_2.pdf"
                                            ,"/tmp/download/file_3.png"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);